import * as Dialog from '@radix-ui/react-dialog';
import React from 'react';
import { motion } from 'framer-motion';

import { Divider } from '../../../settings/billing/billing.styled';

import {
  CenteredContent,
  ModalBody,
  Title,
  Section,
  SectionHeading,
  SectionBody,
  CancelButton,
} from './talk-to-chris.styled';

import { useTalkToChrisModal, TalkToChrisModalProps } from './talk-to-chris.hooks';

const TalkToChrisModal: React.FC<TalkToChrisModalProps> = (props) => {
  const { open, onOpenChange } = props;

  const {
    handleUrgentClick,
    handleOverlayClick,
    handlePointerDownOutside,
    handleContentClick,
  } = useTalkToChrisModal(props);

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          onClick={handleOverlayClick}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.35)',
            zIndex: 1099,
          }}
        />
        <CenteredContent
          onPointerDownOutside={handlePointerDownOutside}
          onClick={handleContentClick}
          aria-describedby={undefined}
        >
          <Dialog.Title style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap' }}>
            Talk to Chris
          </Dialog.Title>
          <motion.div
            initial={{ scale: 0.98, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.98, opacity: 0 }}
            transition={{ duration: 0.18, ease: [0.22, 0.61, 0.36, 1] }}
          >
            <ModalBody>
              <Title>Talk to Chris</Title>
              <Divider />
              <Section onClick={handleUrgentClick} aria-label="Send urgent message">
                <SectionHeading>Send urgent message</SectionHeading>
                <SectionBody dim>
                  If time-sensitive, you can notify Chris immediately via text.
                </SectionBody>
              </Section>

              <CancelButton onClick={() => onOpenChange(false)}>Cancel</CancelButton>
            </ModalBody>
          </motion.div>
        </CenteredContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default TalkToChrisModal;
